import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import MinimalLayout from "layout/MinimalLayout";

const AuthLogin = Loadable(
  lazy(() => import("views/auth/authentication/Login"))
);
const AuthUserForgotPassword = Loadable(
  lazy(() => import("views/auth/authentication/UserForgotPassword"))
);
const AuthRegister = Loadable(
  lazy(() => import("views/auth/authentication/Register"))
);
const AuthForgotPassword = Loadable(
  lazy(() => import("views/auth/authentication/ForgotPassword"))
);
const AuthResetPassword = Loadable(
  lazy(() => import("views/auth/authentication/ResetPassword"))
);
const AuthCodeVerification = Loadable(
  lazy(() => import("views/auth/authentication/CodeVerification"))
);
const AuthAdminLogin = Loadable(
  lazy(() => import("views/auth/authentication/AdminLogin"))
);

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/auth/user-login",
      element: <AuthLogin />,
    },
    {
      path: "/auth/admin-login",
      element: <AuthAdminLogin />,
    },
    {
      path: "/auth/register",
      element: <AuthRegister />,
    },
    {
      path: "/auth/forgot-password",
      element: <AuthForgotPassword />,
    },
    {
      path: "/auth/user-forgot-password",
      element: <AuthUserForgotPassword />,
    },
    {
      path: "/auth/reset-password",
      element: <AuthResetPassword />,
    },
    {
      path: "/auth/email-verification",
      element: <AuthCodeVerification />,
    },
  ],
};

export default AuthenticationRoutes;
